/** French: English wording -> Français. */
export default {
  'Add image': 'Ajouter une image',
  'Admit all': 'Tout admettre',
  'Anyone with the link joins directly': 'Toute personne disposant du lien entre directement',
  'Back to home': 'Retour à l’accueil',
  'Background options': 'Options d’arrière-plan',
  'Calendar not connected': 'Calendrier non connecté',
  'Camera is off': 'La caméra est désactivée',
  'Camera is starting…': 'Démarrage de la caméra…',
  'Can’t reach the host': 'Impossible de joindre l’organisateur',
  'Can’t reach the meeting service. Check your connection and try again.': 'Impossible de joindre le service de réunion. Vérifiez votre connexion et réessayez.',
  'Change background': 'Changer l’arrière-plan',
  'Chat message': 'Message',
  'Choose from Calendar…': 'Choisir dans le calendrier…',
  'Close panel': 'Fermer le panneau',
  'Closed room': 'Salle fermée',
  'Connecting…': 'Connexion…',
  'Connection lost': 'Connexion perdue',
  'Copy joining link': 'Copier le lien d’invitation',
  'Copy meeting code': 'Copier le code de la réunion',
  'Copy meeting link': 'Copier le lien de la réunion',
  'Couldn’t reach Calendar': 'Calendrier inaccessible',
  'Create a meeting for later': 'Créer une réunion pour plus tard',
  'Earlier today': 'Plus tôt aujourd’hui',
  'Enter a code or link': 'Saisissez un code ou un lien',
  'Everyone has left, so the meeting is over.': 'Tout le monde est parti : la réunion est terminée.',
  'Exit full screen': 'Quitter le plein écran',
  'Exit picture-in-picture': 'Quitter l’image dans l’image',
  'Filters out background noise like typing, fans, and traffic': 'Filtre les bruits de fond (clavier, ventilateurs, circulation)',
  'From your CRM': 'Depuis votre CRM',
  'Full screen': 'Plein écran',
  'Guests wait until you let them in': 'Les invités patientent jusqu’à ce que vous les admettiez',
  'Hand raised': 'Main levée',
  'Here’s your meeting link': 'Voici le lien de votre réunion',
  'Host controls': 'Contrôles de l’organisateur',
  'In-call messages': 'Messages de la réunion',
  'Join now': 'Rejoindre',
  'Joining info': 'Informations de connexion',
  'Joining…': 'Connexion…',
  'Keyboard shortcuts': 'Raccourcis clavier',
  'Leave call': 'Quitter la réunion',
  'Leave waiting room': 'Quitter la salle d’attente',
  'Loading…': 'Chargement…',
  'Loading your calendar…': 'Chargement de votre calendrier…',
  'Loading your meetings': 'Chargement de vos réunions',
  'Lock meeting': 'Verrouiller la réunion',
  'Lower hand': 'Baisser la main',
  'Meeting PIN': 'Code PIN de la réunion',
  'Meeting code': 'Code de la réunion',
  'Meeting code copied': 'Code de la réunion copié',
  'Meeting code or link': 'Code ou lien de la réunion',
  'Meeting details': 'Détails de la réunion',
  'Meeting link': 'Lien de la réunion',
  'Meeting link copied': 'Lien de la réunion copié',
  'Meeting link or code': 'Lien ou code de la réunion',
  'Meeting passcode': 'Code d’accès de la réunion',
  'Messages are only visible to people in the call right now and are deleted when the call ends.': 'Les messages ne sont visibles que par les personnes présentes et sont supprimés à la fin de la réunion.',
  'Microphone on': 'Micro activé',
  'More options': 'Plus d’options',
  'Mute everyone': 'Couper le micro de tous',
  'New meeting': 'Nouvelle réunion',
  'New messages': 'Nouveaux messages',
  'Next up': 'À venir',
  'Next week': 'Semaine suivante',
  'No account needed to join': 'Aucun compte nécessaire pour rejoindre',
  'No effect': 'Aucun effet',
  'No meetings with a link': 'Aucune réunion avec un lien',
  'No messages yet': 'Aucun message',
  'No one new can join': 'Personne d’autre ne peut rejoindre',
  'No passcode': 'Aucun code d’accès',
  'Noise suppression': 'Suppression du bruit',
  'Notify the host again': 'Prévenir à nouveau l’organisateur',
  'Open Calendar': 'Ouvrir le calendrier',
  'Open link': 'Ouvrir le lien',
  'Open room': 'Salle ouverte',
  'Or paste a link': 'Ou collez un lien',
  'PIN code (optional)': 'Code PIN (facultatif)',
  'PIN code for guests': 'Code PIN pour les invités',
  'Paste a meeting link or code': 'Collez un lien ou un code de réunion',
  'People': 'Participants',
  'People waiting to join': 'Personnes en attente',
  'Picture-in-picture': 'Image dans l’image',
  'Pin to screen': 'Épingler à l’écran',
  'Please enter your name.': 'Veuillez saisir votre nom.',
  'Present now': 'Présenter',
  'Previous week': 'Semaine précédente',
  'Raise hand': 'Lever la main',
  'Ready to join?': 'Prêt à rejoindre ?',
  'Ready to start?': 'Prêt à démarrer ?',
  'Reconnecting…': 'Reconnexion…',
  'Replace image': 'Remplacer l’image',
  'Restart meeting': 'Relancer la réunion',
  'Return to home screen': 'Retour à l’écran d’accueil',
  'Room type': 'Type de salle',
  'Save nickname': 'Enregistrer le pseudo',
  'Send a message to everyone': 'Envoyer un message à tous',
  'Send a reaction': 'Envoyer une réaction',
  'Send message': 'Envoyer',
  'Settings': 'Paramètres',
  'Sign in through your CRM to start a meeting.': 'Connectez-vous via votre CRM pour démarrer une réunion.',
  'Sign in with trtCRM': 'Se connecter avec trtCRM',
  'Sign out': 'Se déconnecter',
  'Slight blur': 'Flou léger',
  'Start / join': 'Démarrer / rejoindre',
  'Start a new meeting': 'Démarrer une nouvelle réunion',
  'Start an instant meeting': 'Démarrer une réunion instantanée',
  'Start meeting': 'Démarrer la réunion',
  'Start or join': 'Démarrer ou rejoindre',
  'Start this meeting': 'Démarrer cette réunion',
  'Starting soon': 'Bientôt',
  'Starting…': 'Démarrage…',
  'Stop presenting': 'Arrêter la présentation',
  'Stop waiting': 'Arrêter d’attendre',
  'Switch to dark theme': 'Passer au thème sombre',
  'Switch to light theme': 'Passer au thème clair',
  'The meeting has ended': 'La réunion est terminée',
  'The meeting is starting': 'La réunion démarre',
  'The meeting is running': 'La réunion est en cours',
  'Toggle camera': 'Activer/désactiver la caméra',
  'Toggle microphone': 'Activer/désactiver le micro',
  'Try again': 'Réessayer',
  'Turn off camera': 'Désactiver la caméra',
  'Turn off microphone': 'Désactiver le micro',
  'Turn on': 'Activer',
  'Updating…': 'Mise à jour…',
  'Upload an image': 'Téléverser une image',
  'Waiting for the host': 'En attente de l’organisateur',
  'Waiting for the host to let you in': 'En attente de l’autorisation de l’organisateur',
  'Waiting for the host…': 'En attente de l’organisateur…',
  'You left the meeting': 'Vous avez quitté la réunion',
  'Your image': 'Votre image',
  'Your meeting is ready. Share the link to invite others.': 'Votre réunion est prête. Partagez le lien pour inviter d’autres personnes.',
  'Your name': 'Votre nom',
  'Your presentation': 'Votre présentation',
  'You’re sharing your screen': 'Vous partagez votre écran',
  'Rejoin': 'Rejoindre à nouveau',
  'Notes': 'Notes',
  'Start recording': 'Démarrer l’enregistrement',
  'Stop recording': 'Arrêter l’enregistrement',
  'Download notes': 'Télécharger les notes',
  'Your notes are private to you and kept on this device until you close the tab.': 'Vos notes sont privées et conservées sur cet appareil jusqu’à la fermeture de l’onglet.',
  'Write your notes here…': 'Écrivez vos notes ici…',
  'Recording saved to your device': 'Enregistrement sauvegardé sur votre appareil',
  'Recording is not available in this browser.': 'L’enregistrement n’est pas disponible dans ce navigateur.',
  'Language': 'Langue',
  "Loading profile picture": "Chargement de la photo de profil",
  "Meetings from your calendar show up here. Add a trtMeet meeting link to an event in your CRM, and it is one click away.": "Les réunions de votre calendrier apparaissent ici. Ajoutez un lien de réunion trtMeet à un événement de votre CRM et il sera à portée de clic.",
  "Your meetings will show here once the Calendar app answers.": "Vos réunions s’afficheront ici dès que l’application Calendrier répondra.",
  "Couldn’t update from Calendar": "Impossible de mettre à jour depuis le calendrier",
  "Last known": "Dernier état connu",
  "Calendar is not available right now": "Le calendrier n’est pas disponible pour le moment",
  "Enter a meeting code or paste a meeting link.": "Saisissez un code de réunion ou collez un lien de réunion.",
  "Start or rejoin from Calendar": "Démarrer ou rejoindre depuis le calendrier",
  "One moment.": "Un instant.",
  "Your CRM meetings appear here once you are signed in through the CRM. You can still paste a link below.": "Vos réunions CRM apparaissent ici une fois connecté via le CRM. Vous pouvez toujours coller un lien ci-dessous.",
  "The Calendar app didn’t answer. Check that it is installed, then try again — or paste a link below.": "L’application Calendrier n’a pas répondu. Vérifiez qu’elle est installée, puis réessayez — ou collez un lien ci-dessous.",
  "Camera is off. Effects apply when it’s back on": "La caméra est désactivée. Les effets s’appliqueront à sa réactivation",
  "Couldn’t read that image. Try a different file.": "Impossible de lire cette image. Essayez un autre fichier.",
  "Toggle theme": "Changer de thème",
  "Toggle light/dark theme": "Basculer thème clair/sombre",
  "Start a call in seconds, or create a link to share for later. It all runs in your browser.": "Démarrez une réunion en quelques secondes ou créez un lien à partager. Tout fonctionne dans votre navigateur.",
  "Hosts sign in with trtCRM. Joining a meeting needs no account: paste the link or code you were given.": "Les organisateurs se connectent avec trtCRM. Rejoindre une réunion ne nécessite aucun compte : collez le lien ou le code reçu.",
  "Nothing to install": "Rien à installer",
  "Links never expire": "Les liens n’expirent jamais",
  "No CRM is configured.": "Aucun CRM n’est configuré.",
  "Could not set up a reusable link, so this meeting uses a one-time link.": "Impossible de créer un lien réutilisable : cette réunion utilise un lien à usage unique.",
  "Turn off microphone (⌘/Ctrl+D)": "Désactiver le micro (⌘/Ctrl+D)",
  "Turn off camera (⌘/Ctrl+E)": "Désactiver la caméra (⌘/Ctrl+E)",
  "The host left the meeting. Finding a new host…": "L’organisateur a quitté la réunion. Recherche d’un nouvel organisateur…",
  "The host muted your microphone": "L’organisateur a coupé votre micro",
  "Screen sharing failed.": "Le partage d’écran a échoué.",
  "Picture-in-picture isn’t available right now.": "L’image dans l’image n’est pas disponible pour le moment.",
  "Copy failed. Select the link in Meeting details to copy it.": "Échec de la copie. Sélectionnez le lien dans les détails de la réunion pour le copier.",
  "Copy failed. Select the text manually.": "Échec de la copie. Sélectionnez le texte manuellement.",
  "Close panels and menus": "Fermer les panneaux et les menus",
  "Not available": "Non disponible",
  "Nickname saved": "Pseudo enregistré",
  "Shown to everyone in your meeting and remembered for future meetings.": "Affiché à tous dans votre réunion et mémorisé pour les prochaines.",
  "Share this link with people you want in the meeting. It never changes, so anyone with it can join whenever this meeting is running, today or next week.": "Partagez ce lien avec les personnes à inviter. Il ne change jamais : toute personne qui le possède peut rejoindre dès que la réunion est en cours, aujourd’hui ou la semaine prochaine.",
  "Share this link with people you want in the meeting. Anyone with the link can ask to join while the meeting is running.": "Partagez ce lien avec les personnes à inviter. Toute personne qui le possède peut demander à rejoindre pendant la réunion.",
  "Passcode set": "Code d’accès défini",
  "Passcode removed": "Code d’accès supprimé",
  "Join-request alerts are blocked in your browser settings.": "Les alertes de demande d’accès sont bloquées dans les paramètres de votre navigateur.",
  "Get an alert when someone asks to join, even from another tab.": "Recevez une alerte quand quelqu’un demande à rejoindre, même depuis un autre onglet.",
  "Messages can only be seen by people in the call and are deleted when the call ends.": "Les messages ne sont visibles que par les personnes présentes et sont supprimés à la fin de la réunion.",
  "This browser has no picture-in-picture.": "Ce navigateur ne prend pas en charge l’image dans l’image.",
  "Back to the meeting tab": "Retour à l’onglet de la réunion",
  "Turn on a camera or present to float the meeting.": "Activez une caméra ou présentez pour afficher la réunion en flottant.",
  "Open room: anyone with the link joins directly": "Salle ouverte : toute personne disposant du lien entre directement",
  "Try connecting to the meeting again": "Réessayer de se connecter à la réunion",
  "That passcode didn’t work. Check it and try again.": "Ce code d’accès n’a pas fonctionné. Vérifiez-le et réessayez.",
  "This meeting needs a passcode. Ask the host for it.": "Cette réunion nécessite un code d’accès. Demandez-le à l’organisateur.",
  "Could not reach the meeting service to start this meeting. It will be tried again in a moment.": "Impossible de joindre le service pour démarrer cette réunion. Nouvelle tentative dans un instant.",
  "The meeting link couldn’t be updated just now. Guests may not find this meeting until it can be.": "Le lien de la réunion n’a pas pu être mis à jour. Les invités risquent de ne pas la trouver pour l’instant.",
  "The meeting link couldn’t be updated just now. New participants may not find this meeting until it can be.": "Le lien de la réunion n’a pas pu être mis à jour. Les nouveaux participants risquent de ne pas la trouver pour l’instant.",
  "Host notified ✓": "Organisateur prévenu ✓",
  "This is a closed room. We’ve told the host you’re here — stay on this page and you’ll join as soon as they admit you.": "Cette salle est fermée. L’organisateur est prévenu de votre présence : restez sur cette page, vous entrerez dès qu’il vous admettra.",
  "We can’t reach the host right now. They may have lost their connection or left. We’ll keep trying and you’ll be let in as soon as they’re back — or leave and try the link again later.": "Impossible de joindre l’organisateur pour le moment. Il a peut-être perdu sa connexion ou quitté la réunion. Nous réessayons et vous entrerez dès son retour — ou quittez et réessayez le lien plus tard.",
  "Someone is starting the meeting right now. Connecting you — this usually takes a few seconds.": "Quelqu’un démarre la réunion en ce moment. Connexion en cours — cela prend quelques secondes.",
  "Your network is blocking the connection. Try another network or a phone hotspot, or ask the host to check that guests can use relays.": "Votre réseau bloque la connexion. Essayez un autre réseau ou un partage de connexion mobile, ou demandez à l’organisateur de vérifier que les invités peuvent utiliser des relais.",
  "Still trying to get you in. Ask the host to check their connection, or to share the link again.": "Nous essayons toujours de vous faire entrer. Demandez à l’organisateur de vérifier sa connexion ou de partager à nouveau le lien.",
  "Can’t reach the meeting service — retrying…": "Service de réunion inaccessible — nouvelle tentative…",
  "The host is here, but their link is being refreshed. Connecting you — this usually takes a few seconds.": "L’organisateur est présent, mais son lien est en cours d’actualisation. Connexion en cours — quelques secondes.",
  "We can’t reach the meeting service right now. Check your connection — you’ll join automatically once it’s back.": "Le service de réunion est inaccessible. Vérifiez votre connexion — vous rejoindrez automatiquement dès son retour.",
  "The meeting hasn’t started yet. You’ll join automatically when it starts.": "La réunion n’a pas encore commencé. Vous la rejoindrez automatiquement dès son début.",
  "The meeting hasn’t started yet. You’ll join automatically when it starts, or you can start it now.": "La réunion n’a pas encore commencé. Vous la rejoindrez automatiquement dès son début, ou vous pouvez la démarrer maintenant.",
  "You’ll get a reusable link that works every time this meeting runs.": "Vous obtiendrez un lien réutilisable qui fonctionne à chaque tenue de cette réunion.",
  "Sign in to start a meeting — opening the sign-in page…": "Connectez-vous pour démarrer une réunion — ouverture de la page de connexion…",
  "You and the host are on different versions of trtMeet. Both of you should hard-refresh the page (⌘/Ctrl+Shift+R) and try again with a new meeting link.": "Vous et l’organisateur utilisez des versions différentes de trtMeet. Actualisez tous les deux la page (⌘/Ctrl+Maj+R) et réessayez avec un nouveau lien.",
  "Connected, but the meeting never answered. Make sure the host still has the meeting open. If this keeps happening, both of you should hard-refresh the page (⌘/Ctrl+Shift+R) to get the latest version.": "Connecté, mais la réunion n’a pas répondu. Vérifiez que l’organisateur a toujours la réunion ouverte. Si cela continue, actualisez tous les deux la page (⌘/Ctrl+Maj+R) pour obtenir la dernière version.",
  "Could not reach the meeting. Check the code and try again.": "Impossible de joindre la réunion. Vérifiez le code et réessayez.",
  "The meeting is unavailable. The host may have left.": "La réunion est indisponible. L’organisateur a peut-être quitté.",
  "Your preview is hidden to prevent mirroring.": "Votre aperçu est masqué pour éviter l’effet miroir.",
  "The host removed you from the meeting.": "L’organisateur vous a retiré de la réunion.",
  "Your meeting link is working again.": "Le lien de votre réunion fonctionne à nouveau.",
  "Someone else started a meeting on this link at the same time. New participants will join theirs; this meeting carries on for everyone in it.": "Quelqu’un d’autre a démarré une réunion sur ce lien en même temps. Les nouveaux participants rejoindront la sienne ; celle-ci continue pour ses participants.",
  "The meeting continued under a new host while you were disconnected. New participants will join them.": "La réunion s’est poursuivie avec un nouvel organisateur pendant votre déconnexion. Les nouveaux participants le rejoindront.",
  "The meeting continued under a new host while you were disconnected — you’ve rejoined it.": "La réunion s’est poursuivie avec un nouvel organisateur pendant votre déconnexion — vous l’avez rejointe.",
  "Someone else started this meeting at the same time — you’ve joined them.": "Quelqu’un d’autre a démarré cette réunion en même temps — vous l’avez rejoint.",
  "Your trtCRM session has ended. You can finish this call; you will be signed out when it ends.": "Votre session trtCRM a pris fin. Vous pouvez terminer cette réunion ; vous serez déconnecté à sa fin.",
  "Captions": "Sous-titres",
  "Turn on captions": "Activer les sous-titres",
  "Turn off captions": "Désactiver les sous-titres",
  "Captions are not available in this browser.": "Les sous-titres ne sont pas disponibles dans ce navigateur.",
  "Assistant": "Assistant",
  "Meeting assistant": "Assistant de réunion",
  "Summarize the meeting": "Résumer la réunion",
  "Ask about the meeting…": "Posez une question sur la réunion…",
  "Ask": "Demander",
  "Thinking…": "Réflexion…",
  "Turn on captions first: the assistant works from what was said.": "Activez d’abord les sous-titres : l’assistant se base sur ce qui a été dit.",
  "The assistant could not answer right now. Try again in a moment.": "L’assistant n’a pas pu répondre. Réessayez dans un instant.",
  "The assistant reads the captions of this meeting and sends them to an AI service to answer. Only team members can use it.": "L’assistant lit les sous-titres de cette réunion et les envoie à un service d’IA pour répondre. Réservé aux membres de l’équipe.",
  "Download transcript": "Télécharger la transcription",
  "Book a meeting": "Prendre rendez-vous",
  "Pick a day and an hour that suit you. Meetings last one hour.": "Choisissez un jour et une heure qui vous conviennent. Les rendez-vous durent une heure.",
  "Previous month": "Mois précédent",
  "Next month": "Mois suivant",
  "Bookings are not available right now. Try again in a moment.": "Les réservations ne sont pas disponibles pour le moment. Réessayez dans un instant.",
  "No free hours this month.": "Aucun créneau libre ce mois-ci.",
  "Email": "E-mail",
  "Phone (optional)": "Téléphone (facultatif)",
  "What would you like to talk about? (optional)": "De quoi souhaitez-vous parler ? (facultatif)",
  "Confirm booking": "Confirmer la réservation",
  "Sending…": "Envoi…",
  "Back": "Retour",
  "Please enter a valid email address.": "Veuillez saisir une adresse e-mail valide.",
  "Please enter a valid phone number.": "Veuillez saisir un numéro de téléphone valide.",
  "Sorry, that hour was just taken. Please pick another.": "Désolé, ce créneau vient d’être pris. Choisissez-en un autre.",
  "You already have several upcoming bookings.": "Vous avez déjà plusieurs rendez-vous à venir.",
  "Too many attempts. Please try again later.": "Trop de tentatives. Réessayez plus tard.",
  "Could not book right now. Please try again.": "Réservation impossible pour le moment. Veuillez réessayer.",
  "Your meeting is booked": "Votre rendez-vous est confirmé",
  "Keep this link. At the time, open it to join:": "Conservez ce lien. À l’heure du rendez-vous, ouvrez-le pour rejoindre :",
  "Add to calendar": "Ajouter au calendrier",
  "Book another": "Réserver un autre créneau",
  "Appointments": "Rendez-vous",
  "Step 1 of 3": "Étape 1 sur 3",
  "Step 2 of 3": "Étape 2 sur 3",
  "Step 3 of 3": "Étape 3 sur 3",
  "Date and time": "Date et heure",
  "Your details": "Vos coordonnées",
  "Your needs": "Vos besoins",
  "Phone": "Téléphone",
  "Country": "Pays",
  "Services needed": "Services souhaités",
  "Website (optional)": "Site web (facultatif)",
  "Next": "Suivant",
  "Please choose your country.": "Veuillez choisir votre pays.",
  "Choose at least one service.": "Choisissez au moins un service.",
  "Please enter a valid website address.": "Veuillez saisir une adresse de site valide.",
  "Accept": "Accepter",
  "Edit": "Modifier",
  "Delete": "Supprimer",
  "Cancel": "Annuler",
  "Save": "Enregistrer",
  "Pending": "En attente",
  "Not in CRM": "Pas dans le CRM",
  "Send to CRM": "Envoyer au CRM",
  "Send all to CRM": "Tout envoyer au CRM",
  "Delete this appointment?": "Supprimer ce rendez-vous ?",
  "The hour becomes free again for other visitors.": "Le créneau redevient disponible pour les autres visiteurs.",
  "Edit appointment": "Modifier le rendez-vous",
  "Name": "Nom",
  "Note": "Note",
  "Your request was sent": "Votre demande a été envoyée",
  "We will confirm this hour shortly. Keep this link; at the time, open it to join:": "Nous confirmerons ce créneau rapidement. Conservez ce lien ; à l’heure du rendez-vous, ouvrez-le pour rejoindre :",
  "That hour is taken.": "Ce créneau est déjà pris.",
  "Could not save.": "Enregistrement impossible.",
  "Refuse": "Refuser",
  "Refuse this appointment?": "Refuser ce rendez-vous ?",
  "The hour becomes free again and the CRM tells the visitor.": "Le créneau redevient disponible et le CRM prévient le visiteur.",
  "Saved here, but the CRM did not accept the change.": "Enregistré ici, mais le CRM n’a pas accepté la modification.",
  "Done. The CRM calendar is updated.": "Terminé. Le calendrier du CRM est à jour.",
  "Done.": "Terminé.",
  "Open the CRM calendar": "Ouvrir le calendrier du CRM",
  "Sign in": "Se connecter",
  "Prepare the recap for the CRM": "Préparer le compte rendu pour le CRM",
  "Create this task": "Créer cette tâche",
  "Task": "Tâche",
  "Recap": "Compte rendu",
  "Decisions": "Décisions",
  "Open questions": "Questions ouvertes",
  "Action items": "Actions à mener",
  "Save to the CRM": "Enregistrer dans le CRM",
  "Saving…": "Enregistrement…",
  "Saved on the CRM event": "Enregistré sur l'événement du CRM",
  "task(s) created": "tâche(s) créée(s)",
  "already there": "déjà existante(s)",
  "No event of the CRM calendar uses this meeting link: create the event in the CRM calendar with this link, then save again.": "Aucun événement du calendrier du CRM n'utilise ce lien : créez l'événement dans le calendrier du CRM avec ce lien, puis enregistrez à nouveau.",
  "You cannot write on that CRM event.": "Vous ne pouvez pas écrire sur cet événement du CRM.",
  "Could not save to the CRM right now. Try again in a moment.": "Impossible d'enregistrer dans le CRM pour le moment. Réessayez dans un instant.",
};
